"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _avlComponents = require("@availabs/avl-components");

var _matchSorter = require("match-sorter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UserHeader = function UserHeader(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["value", "onChange"]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-9 font-bold gap-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-4 border-b-2"
  }, /*#__PURE__*/_react["default"].createElement("div", null, "User Email"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-1"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Input, {
    small: true,
    showClear: true,
    placeholder: "Searh users...",
    value: value,
    onChange: onChange
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3 border-b-2 flex justify-center items-end"
  }, "Remove from Group"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 border-b-2 flex justify-center items-end"
  }, "Delete User"));
};

var UserInGroup = function UserInGroup(_ref2) {
  var group = _ref2.group,
      User = _ref2.User,
      removeFromGroup = _ref2.removeFromGroup,
      deleteUser = _ref2.deleteUser,
      props = _objectWithoutProperties(_ref2, ["group", "User", "removeFromGroup", "deleteUser"]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-9 my-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-4"
  }, User.email), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3 flex justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    showConfirm: true,
    onClick: function onClick(e) {
      return removeFromGroup(User.email, group.name);
    }
  }, "remove")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 flex justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    showConfirm: true,
    buttonTheme: "buttonDanger",
    onClick: function onClick(e) {
      return deleteUser(User.email);
    }
  }, "delete")));
};

var UserNotInGroup = function UserNotInGroup(_ref3) {
  var group = _ref3.group,
      User = _ref3.User,
      assignToGroup = _ref3.assignToGroup,
      props = _objectWithoutProperties(_ref3, ["group", "User", "assignToGroup"]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-12 mb-1 flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-8"
  }, User.email), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-4"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    onClick: function onClick(e) {
      return assignToGroup(User.email, group.name);
    }
  }, "add to group")));
};

var _default = function _default(_ref4) {
  var group = _ref4.group,
      users = _ref4.users,
      props = _objectWithoutProperties(_ref4, ["group", "users"]);

  var _React$useState = _react["default"].useState(5),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      num = _React$useState2[0],
      setNum = _React$useState2[1],
      _React$useState3 = _react["default"].useState(""),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      userSearch = _React$useState4[0],
      setUserSearch = _React$useState4[1],
      _React$useState5 = _react["default"].useState(""),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      otherUserSearch = _React$useState6[0],
      setOtherUserSearch = _React$useState6[1],
      _users$reduce = users.reduce(function (_ref5, c) {
    var _ref6 = _slicedToArray(_ref5, 2),
        a1 = _ref6[0],
        a2 = _ref6[1];

    if (c.groups.includes(group.name)) {
      a1.push(c);
    } else {
      a2.push(c);
    }

    return [a1, a2];
  }, [[], []]),
      _users$reduce2 = _slicedToArray(_users$reduce, 2),
      usersInGroup = _users$reduce2[0],
      otherUsers = _users$reduce2[1];

  usersInGroup.sort(function (a, b) {
    return a.email < b.email ? -1 : a.email > b.email ? 1 : 0;
  });
  var otherSearch = (0, _matchSorter.matchSorter)(otherUsers, otherUserSearch, {
    keys: ["email"]
  });
  console.log("???", usersInGroup);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-5 grid grid-cols-3 gap-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-1 relative"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Input, {
    value: otherUserSearch,
    onChange: setOtherUserSearch,
    placeholder: "Search for another user...",
    showClear: true
  }), otherUserSearch && otherSearch.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute left-0 bottom-0 right-0"
  }, otherSearch.length <= 5 ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    onClick: function onClick(e) {
      return setNum(num - 5);
    },
    disabled: num === 5,
    className: "mx-1"
  }, "Show Less"), /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    onClick: function onClick(e) {
      return setNum(num + 5);
    },
    disabled: num > otherSearch.length,
    className: "mx-1"
  }, "Show More"))) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2"
  }, !otherUserSearch ? null : /*#__PURE__*/_react["default"].createElement("div", null, otherSearch.length ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-1"
  }, "No users found..."), otherSearch.slice(0, num).map(function (u) {
    return /*#__PURE__*/_react["default"].createElement(UserNotInGroup, _extends({}, props, {
      key: u.email,
      group: group,
      User: u
    }));
  }), otherSearch.length < num ? null : /*#__PURE__*/_react["default"].createElement("div", null, "Plus ", otherSearch.length - num, " others...")))), /*#__PURE__*/_react["default"].createElement(UserHeader, {
    onChange: setUserSearch,
    value: userSearch
  }), (0, _matchSorter.matchSorter)(usersInGroup, userSearch, {
    keys: ["email"]
  }).map(function (user) {
    return /*#__PURE__*/_react["default"].createElement(UserInGroup, _extends({}, props, {
      key: user.email,
      User: user,
      group: group
    }), user.email);
  }));
};

exports["default"] = _default;